export default __webpack_public_path__ + "static/media/pr_c_28.686ebea1.jpg";